import { createRouter } from '@tanstack/react-router';
import { AUTH_ROUTES } from '@/features/auth/consts/routes';
import { onSignedOutElsewhere } from '@/features/auth/utils/session-broadcast';
import { routeTree } from '@/routes';
import { appQueryClient } from '../tanstack-query/root-provider';
import { AUTH_ROUTE_ID } from './auth-route-id';

export const router = createRouter({
  routeTree,
  context: {
    queryClient: appQueryClient,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

onSignedOutElsewhere(() => {
  const isSignedInPage = router.state.matches.some(
    (match) => match.routeId === `/${AUTH_ROUTE_ID}`,
  );

  if (!isSignedInPage) return;

  void router.navigate({
    to: AUTH_ROUTES.login,
    search: { redirect: router.state.location.href },
    replace: true,
    ignoreBlocker: true,
    reloadDocument: true,
  });
});
